var _style, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSearchIconWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 15.8 15.8",
    style: {
      enableBackground: "new 0 0 15.8 15.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M15.9,17l-5-5c-0.4,0.3-0.9,0.5-1.4,0.7C9.1,12.9,8.6,13,8,13c-1.4,0-2.6-0.5-3.5-1.5C3.5,10.6,3,9.4,3,8 s0.5-2.6,1.5-3.5C5.4,3.5,6.6,3,8,3s2.6,0.5,3.5,1.5c1,1,1.5,2.2,1.5,3.5c0,0.6-0.1,1.1-0.3,1.6c-0.2,0.5-0.4,1-0.7,1.4l5,5L15.9,17 z M8,11.5c1,0,1.8-0.3,2.5-1s1-1.5,1-2.5s-0.3-1.8-1-2.5S9,4.5,8,4.5s-1.8,0.3-2.5,1S4.5,7,4.5,8s0.3,1.8,1,2.5S7,11.5,8,11.5z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIconWhite);
export default __webpack_public_path__ + "static/media/SearchIconWhite.19a4ec2952e6aad17b4efeda154b24fb.svg";
export { ForwardRef as ReactComponent };